<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="text-center mt-5">
                    <router-link :to="{ name: 'home' }">
                        aNew<span class="text-dark-green">Item</span> 
                    </router-link> Payments
                </h2>
            </div>
            <div class="col-12 offset-0 col-md-8 offset-md-2">
                <!-- display alerts -->
                <div v-if="msg !== ''" :class="`alert alert-${color} text-center mb-2 mt-2 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </div>
        </div>
        <div v-if="payObj" class="row mb-n4">
            <div class="col-12 offset-0 col-md-8 offset-md-2">
                <div class="card text-center">
                    <div class="card-header">
                        <i class="far fa-check-circle text-dark-green fa-2x mb-2"></i>
                        <p class="m-0">One-Time Payment Receipt</p>
                    </div>
                    <div class="card-body">
                        <p>
                            Your payment to 
                            <router-link :to="{ name: 'user-handle', params: { handle: payObj.userHandle } }">
                                <span class="text-dark-green">@{{payObj.userHandle}}</span> 
                            </router-link>
                            (<span v-if="payObj.shopOwner">{{payObj.shopName}}</span> 
                            <span v-else>{{payObj.name | capitalize}}</span>)
                            for item
                        </p>
                        <p class="text-dark-green">
                            <router-link :to="{ name: 'listItem', params: { id: payObj.itemId } }">
                                "{{payObj.title}}"
                            </router-link>
                        </p>
                        <p class="fa-lg text-uppercase">{{payObj.currency}} {{payObj.amount | money}}</p>
                        <p>On {{payObj.paidTime | moment("ddd, MMM Do YYYY, h:mm:ss A")}}, was successful!</p>
                        <p>Confirmation Code: <span class="text-dark-green">{{payObj.confCode}}</span></p>
                        <small class="font-italic">
                            * ensure you <span class="text-danger">screenshot</span> 
                            a copy for yourself and the seller referrence! *
                        </small>
                    </div>
                    <div class="card-footer bg-white">
                        <small class="m-0">
                            Thank you for using 
                            <router-link :to="{ name: 'home' }">
                                aNew<span class="text-dark-green">Item</span> Payments
                            </router-link>
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <p class="text-dark-green text-center mt-5">
            <router-link :to="{ name: 'home' }">&copy; aNewItem</router-link>
        </p>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

import LayoutAuth from '@/layouts/Auth.vue' 

export default {
    name: "PaymentReceipt",
    data() {
        return {
            payObj: null,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['fetchPaymentLink', 'completePayment']),
        runFetchPayment() {
            let paymentObj = {
                paymentId: this.$route.params.paymentId
            }
            this.fetchPaymentLink(paymentObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    setTimeout(() => {
                        window.location = data.result.payLink
                    }, 1000) // simulate ajax-call ;-)
                }
                this.msg = data.msg
            })
            .catch((e) => {
                this.msg = 'Unable to fetch payment resources at this time! Try again'
            })
        },
        runCompletePayment(transactionId) {
            // very important! It stops the page from going into loop!
            if(!transactionId) return
            let paymentObj = {
                transactionId,
                paymentId: this.$route.params.paymentId,
            }
            this.completePayment(paymentObj) 
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                    this.payObj = data.result
                    // convert to string and store as redundancy measure
                    localStorage.setItem('_p89rc49s', JSON.stringify(this.payObj))
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        }
    },
    mounted() {
        this.payObj = null

        // very important to ensure this page don't go into loop cycle
        if(!this.$route.query.status){
            // first, check to re-fetch the receipt from local storage if any
            if(localStorage.getItem('_p89rc49s')){
                this.payObj = JSON.parse(localStorage.getItem('_p89rc49s'))
                // wipe off the stored payment receipt if a new payment link is launched
                if(this.$route.params.paymentId !== this.payObj.paymentId){
                    this.runFetchPayment()
                }
            } 
            // second, proceed to fetch payment details fresh from api db
            else {
                this.runFetchPayment()
            }
        }

        // proceed to verify the new payment 
        if(this.$route.query.status && this.$route.query.status === "successful"){
            this.runCompletePayment(this.$route.query.transaction_id)
        }
    },
    created() {
        this.$emit('update:layout', LayoutAuth);
    }
}
</script>